import Vue from 'vue';
import App from './App';
import router from './router';
import VueResource from 'vue-resource'

import './utils/flexible';
import './assets/_global';
import { Toast, InfiniteScroll, Loadmore,Indicator } from 'mint-ui';
import Cookie from './utils/cookie';

Vue.use(VueResource);
Vue.use(InfiniteScroll);
Vue.component(Loadmore.name, Loadmore);

router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
});


Vue.filter('formatDate', (str) => {
  if(str){
    return str.split(' ')[0];
  }else{
    return ''
  }
})
Vue.http.options.emulateJSON =  true;
Vue.http.interceptors.push((request, next) => {
  next((response) => {
    // 跨域携带cookie
    request.credentials = true;
    // 请求发送后的处理逻辑
    request.headers['Content-Type'] = 'application/x-www-form-urlencoded';
    // 根据请求的状态，response参数会返回给successCallback或errorCallback
    var data = response.body;
    if(response.status == 200 || response.status === 304 || response.status === 400) {
      if(data.code != '0001') {
        if(data.message){
          Toast(data.message);
        }
        return response
      } else {
        return response
      }
    } else {
      Toast(response.status+'访问出错，请联系管理员');
      Indicator.close();
    }
  })
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  render: h => h(App),
});

// Vue.http.post('https://tradedev.worldunion.com.cn/apigw-ftdev4/trade/sysConfig/queryAppConfigs',
// Vue.http.post('/trade/sysConfig/queryAppConfigs',
//   {"segment1": "slacapp"}
//   ,{
//     headers: {
//       'Content-Type': 'application/json'
//     }
//   }).then(function(res){
//     console.log(res)
//     // Vue.http.options.root = ‘http://vue.studyit.io/’;   //全局配置
//     // Cookie.set('baseUrl')
    

// }, function(error){
//     console.log(error)
// });









// WEBPACK FOOTER //
// ./src/main.js